import { render, staticRenderFns } from "./PartnersComponent.vue?vue&type=template&id=64556f17&scoped=true&"
import script from "./PartnersComponent.vue?vue&type=script&lang=js&"
export * from "./PartnersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64556f17",
  null
  
)

export default component.exports